import { PageHero } from "../components/site/PageHero";
import { Reveal, Eyebrow } from "../components/site/Reveal";
import { CTA } from "../components/site/CTA";
import { FIRM } from "../data/firm";

const VALUES = [
  ["Regulatory depth", "Over a decade spent inside the rules that govern Indian market intermediaries — circulars, master circulars, bye-laws and inspection practice."],
  ["Practitioner's lens", "Advice that works on a busy trading day, not just on paper. Processes your team can actually run."],
  ["Independent assurance", "Audits and certifications carried out with the independence and diligence expected of a Practising Company Secretary."],
  ["Personal attention", "As a proprietorship, every engagement is led directly by the principal — no hand-offs."],
];

const BIO = [
  "Jay Kular is a Company Secretary and legal professional with over a decade of experience in the Indian securities market, specializing in SEBI regulations, regulatory compliance, audits, and advisory services.",
  "He has extensive experience in compliance matters relating to Stock Brokers, Depository Participants (DPs), Portfolio Management Services (PMS), Alternative Investment Funds (AIFs), Investment Advisers (IAs), and Research Analysts (RAs).",
  "With a strong understanding of securities market regulations and practical industry requirements, Jay focuses on providing customized, result-oriented compliance solutions that help regulated entities strengthen their governance, streamline compliance processes, and meet evolving regulatory expectations.",
  "Through Jay Kular & Associates, established in April 2026, he is committed to delivering professional, reliable, and client-focused services built on regulatory expertise, integrity, and long-term professional relationships.",
];

export default function About() {
  return (
    <>
      <PageHero
        testid="about-hero"
        eyebrow="About the firm"
        lines={["Quiet rigour,", <span className="font-serif-i text-[var(--brass-deep)]">loud results.</span>]}
        intro="Jay Kular & Associates is a firm of Practising Company Secretaries specialising in compliance, regulatory advisory, audit and documentation services to SEBI-regulated entities."
      />
      <section className="bg-paper py-24 sm:py-32">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16">
          <Reveal className="lg:col-span-5">
        <div className="relative overflow-hidden rounded-[28px] bg-paper border border-ink/10 shadow-2xl">
        <img src="/images/jay-kular.jpg" alt="Jay Kular, Founder & Principal Consultant" data-testid="about-portrait" className="w-full aspect-[4/5] object-cover object-top" />
        <div className="absolute bottom-0 inset-x-0 p-6 bg-gradient-to-t from-[#0a1424]/90 to-transparent">
          <p className="font-mono-x text-xs uppercase tracking-[0.2em] text-brass">{FIRM.title}</p>
          <p data-testid="about-proprietor" className="mt-1 font-display font-bold text-2xl text-paper">{FIRM.proprietor}</p>
        </div>
      </div>
          </Reveal>
          <div className="lg:col-span-7">
            <Eyebrow>Our story</Eyebrow>
            <Reveal>
              <p className="mt-8 font-serif-i text-3xl sm:text-4xl leading-tight text-ink">
                “To make regulatory compliance simpler, more effective, and value-driven for every client.”
              </p>
              <div className="mt-10 space-y-5 text-base sm:text-lg text-ink/75 leading-relaxed">
                {BIO.map((p) => <p key={p.slice(0, 20)}>{p}</p>)}
              </div>
            </Reveal>
          </div>
        </div>
      </section>
      <section className="bg-paper-2 py-24 sm:py-32">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
          <Eyebrow>What we stand for</Eyebrow>
          <div className="mt-12 grid sm:grid-cols-2 border-t border-l border-ink/15">
            {VALUES.map(([t, d], i) => (
              <Reveal key={t} delay={(i % 2) * 0.08} className="border-r border-b border-ink/15 p-8 sm:p-12">
                <span className="font-mono-x text-sm text-[var(--brass-deep)]">0{i + 1}</span>
                <h3 className="mt-4 font-display font-bold text-2xl sm:text-3xl tracking-tight">{t}</h3>
                <p className="mt-4 text-ink/70 leading-relaxed">{d}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <CTA />
    </>
  );
}
